export default __webpack_public_path__ + "static/448-888ccec64e8aed9359db08160f365bdf.gif";